import { Icon } from '@design-system';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React from 'react';

interface Props {
  rank?: number;
  amount?: string;
  isWinning?: boolean;
  target?: string;
}

export const Status = ({ amount, isWinning, rank, target }: Props) => {
  const { t } = useTranslation('product');

  const getStatusText = () => {
    if (rank && amount) {
      if (isWinning) {
        return t('auction.ranked.status.win', {
          rank,
          amount,
        });
      }
      return t('auction.ranked.status.lose', {
        target,
      });
    }

    if (!rank && amount) {
      if (isWinning) {
        return t('auction.default.status.win');
      }
      return t('auction.default.status.lose', {
        amount,
        target,
      });
    }

    return null;
  };

  const isDanger = rank && amount && !isWinning;

  return (
    <div
      className={classNames(
        'inline-flex gap-3 rounded-sm p-3 text-neutral-6',
        isDanger ? 'bg-active-1' : 'bg-neutral-1',
      )}
    >
      <Icon
        className={classNames(
          'shrink-0',
          isDanger ? 'text-active-4' : 'text-neutral-4',
        )}
        name="ic_info"
      />
      <span>{getStatusText()}</span>
    </div>
  );
};
